import React, { createElement, isValidElement, useEffect } from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, isContentfulString, resolveBackgroundColor, resolveColor } from '@philips-internal/oswald-ui-utils';
import { InlineImage } from '../../inline-image/inline-image.js';
import { useOptionalLegends } from '../../legends/legends-context.js';
import { TooltipTrigger } from '../../tooltip/tooltip-constants.js';
import { Tooltip } from '../../tooltip/tooltip.js';
import { SuperscriptionItemProperties } from './superscription-item-types.js';
function SuperscriptionItemIcon(props) {
    const { color, icon } = props;
    const style = resolveBackgroundColor(color);
    if (isValidElement(icon)) {
        const className = `c-superscription__item-icon ${icon.props.className ?? ''}`;
        return createElement(icon.type, {
            ...icon.props,
            className,
            style: {
                fill: resolveColor(color),
            },
        });
    }
    if (isContentfulString(icon)) {
        return (React.createElement(InlineImage, { className: "c-superscription__item-icon", src: icon, style: resolveColor(color) }));
    }
    return (React.createElement("div", { className: "c-superscription__circle", style: style }));
}
function SuperscriptionItem(props) {
    const { color, icon, label = SuperscriptionItemProperties.label.defaultValue, showLabel, value, } = props;
    const context = useOptionalLegends();
    useEffect(() => {
        context?.addItem({ color, icon, label, value });
        return () => {
            context?.removeItem(value);
        };
    }, [props]);
    const className = classNames({
        'c-superscription__item': true,
        [`${props.className}`]: Boolean(props.className),
    });
    return (React.createElement(Tooltip, { triggers: [showLabel ? TooltipTrigger.ELLIPSIS : TooltipTrigger.HOVER], value: label },
        React.createElement("div", { className: className },
            React.createElement(SuperscriptionItemIcon, { color: color, icon: icon }),
            showLabel ? (React.createElement("span", { className: "c-superscription__label u-truncate" }, MessageService.translate(label ?? ''))) : null)));
}
export { SuperscriptionItem, };
//# sourceMappingURL=superscription-item.js.map